import Resource from '../resource';

export default class Registration extends Resource{
	constructor(){
		super('students/register');
	}
}